<template>
    <v-form>
        <div class="az-form-content dados-gerais">
            <v-container fluid grid-list-xl white>
                <painel-processo-legado-visualizacao v-model="compraLegada"/>

                <v-flex xs12 sm12 d-block class="card-dados">
                    <h3 class="card-dados__titulo">Dados da Compra Direta</h3>
                    <v-layout wrap align-center white>
                        <v-flex xs12 sm3 d-flex>
                            <div id="numeroCompraDireta" class="az-text">
                                <label>Nº Compra Direta</label>
                                <p>
                                    {{ compraLegada.numero || '--' }}
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex>
                            <div id="amparoLegal" class="az-text">
                                <label>Observação Comp. Legal</label>
                                <p>{{ compraLegada.amparoLegal || '--' }}</p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex>
                            <div class="az-text">
                                <label>Critério de Julgamento</label>
                                <p>{{ compraLegada.criterioJulgamento }}</p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex>
                            <div id="dataHoraAbertura" class="az-text">
                                <label>Data/Hora de Criação</label>
                                <p>{{ compraLegada.dataHoraAbertura | az-date(humanizarFormatoDataHora(compraLegada.dataHoraAbertura))}}</p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex id="recurso-federal">
                            <div class="az-text">
                                <label>Recurso Federal</label>
                                <p>{{ compraLegada.recursoFederal }}</p>
                            </div>
                        </v-flex>

                        <v-flex xs12 sm3 d-flex v-if="compraLegada.recursoFederal === 'SIM'" id="tipo-transferencia">
                            <div class="az-text">
                                <label>Tipo Transferência</label>
                                <p>{{ compraLegada.tipoTransferencia || '--'}}</p>
                            </div>
                        </v-flex>

                        <v-flex xs12 sm3 d-flex v-if="ehTipoTransferenciaVoluntarios" id="n-convenio">
                            <div class="az-text">
                                <label>Nº Convênio</label>
                                <p>{{ compraLegada.numeroConvenio || '--' }}</p>
                            </div>
                        </v-flex>

                        <v-flex xs12 sm3 d-flex v-if="ehTipoTransferenciaVoluntarios" id="ano-instrumento">
                            <div class="az-text">
                                <label>Ano Instrumento</label>
                                <p>{{ compraLegada.anoInstrumento || '--' }}</p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex v-if="ehTipoTransferenciaVoluntarios" id="legislacao">
                            <div class="az-text">
                                <label>Legislação</label>
                                <p>{{compraLegada.legislacao || '--'}}</p>
                            </div>
                        </v-flex>

                        <v-flex xs12 sm3 d-flex v-if="ehTipoTransferenciaVoluntarios" id="tipo-objeto">
                            <div class="az-text">
                                <label>Tipo Objeto</label>
                                <p>{{compraLegada.tipoObjeto || '--'}}</p>
                            </div>
                        </v-flex>

                        <v-flex xs12 sm3 d-flex v-if="ehTipoTransferenciaVoluntarios" id="origem-recurso">
                            <div class="az-text">
                                <label>Origem Recurso</label>
                                <p>{{compraLegada.origemRecurso || '--'}}</p>
                            </div>
                        </v-flex>

                        <v-flex xs12 sm12 d-flex>
                            <div id="obs" class="az-text">
                                <label>Justificativa contratação</label>
                                <p style="white-space: pre-line;">{{ compraLegada.justificativa || '--'}}</p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 d-flex>
                            <div id="obs" class="az-text">
                                <label>Observação</label>
                                <p style="white-space: pre-line;">{{ compraLegada.observacao || '--'}}</p>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap align-center white>



                    </v-layout>
                </v-flex>
            </v-container>
        </div>

    </v-form>
</template>

<script>
import {actionTypes, tiposTransferencia} from '@/core/constants'
import {mapState} from 'vuex'
import PainelProcessoLegadoVisualizacao from '@/views/pages/comprador/legado/components/PainelProcessoLegadoVisualizacao'

export default {
    name: 'CompraDiretaLegadaDetalhesCapa',
    components: {
        PainelProcessoLegadoVisualizacao,
    },
    computed: {
        tiposTransferencia() {
            return tiposTransferencia
        },
        ...mapState(['loki', 'parametros', 'dadosGerais']),
        ehTipoTransferenciaVoluntarios(){
            return this.compraLegada.tipoTransferencia === 'VOLUNTARIA'
        },
    },
    data() {
        return {
            compraLegada:{},
            compraLegadaId: null,
        }
    },
    async mounted() {
        try {
            this.setCompraLegadaId()
            await this.buscarDadosCapaProcesso()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarDadosCapaProcesso(){
            this.setMensagemLoading('Carregando dados capa processo...')
            this.compraLegada = await this.$store.dispatch(actionTypes.LEGADO.BUSCAR_PROCESSO_POR_ID, this.compraLegadaId)
        },
        setCompraLegadaId() {
            this.compraLegadaId = this.$route.params.id
        },
    }
}
</script>

<style scoped lang="stylus">

</style>
